import * as _ from "lodash";
import { Portfolio, getPortfolios } from "./portfolios";
var InvestmentAccount = /** @class */ (function () {
    function InvestmentAccount(init) {
        this.accountId = 1;
        this.accountName = "New";
        this.accountMarketValue = 1000000;
        this.accountType = InvestmentAccountType.LivingAnnuity;
        this.accountNumber = "New";
        this.portfolios = [];
        this.incomeWithdrawalWeight = 100;
        this.hasDedicatedIncomeBucket = false;
        Object.assign(this, init);
    }
    return InvestmentAccount;
}());
export { InvestmentAccount };
export var InvestmentAccountType;
(function (InvestmentAccountType) {
    InvestmentAccountType[InvestmentAccountType["LivingAnnuity"] = 0] = "LivingAnnuity";
    InvestmentAccountType[InvestmentAccountType["Discretionary"] = 1] = "Discretionary";
    InvestmentAccountType[InvestmentAccountType["Tfsa"] = 2] = "Tfsa";
    InvestmentAccountType[InvestmentAccountType["Property"] = 3] = "Property";
})(InvestmentAccountType || (InvestmentAccountType = {}));
var PortfolioWeight = /** @class */ (function () {
    function PortfolioWeight(init) {
        this.portfolio = new Portfolio();
        this.weight = 100;
        Object.assign(this, init);
    }
    return PortfolioWeight;
}());
export { PortfolioWeight };
export function getAccounts() {
    var accounts = [];
    var portfolios = getPortfolios();
    var portfolioWeights = [];
    portfolioWeights.push(new PortfolioWeight({ portfolio: portfolios[0], weight: 100 }));
    accounts.push(new InvestmentAccount({
        accountId: 1,
        accountName: "Investec",
        accountNumber: "123",
        accountMarketValue: 1500000,
        portfolios: portfolioWeights
    }));
    return accounts;
}
export function getAccountTypes() {
    var accountTypes = [];
    for (var item in InvestmentAccountType) {
        console.log("item", item);
        if (isNaN(Number(item))) {
            accountTypes.push(item);
        }
    }
    return accountTypes;
}
export function getTotalAccounts(accounts) {
    var totalAccounts = [];
    for (var a = 0; a <= accounts.length - 1; a++) {
        totalAccounts.push(accounts[a]);
    }
    var totalValue = Number(_.sumBy(accounts, "accountMarketValue"));
    totalAccounts.push(new InvestmentAccount({
        accountName: "Total",
        accountId: 0,
        accountMarketValue: totalValue
    }));
    return totalAccounts;
}
export function getTotalAccountPortfolios(account) {
    var totalPortfolios = [];
    for (var a = 0; a <= account.portfolios.length - 1; a++) {
        totalPortfolios.push(account.portfolios[a]);
    }
    var totalWeight = _.sumBy(account.portfolios, "weight");
    totalPortfolios.push(new PortfolioWeight({
        portfolio: new Portfolio({ portfolioId: 0, portfolioName: "Total" }),
        weight: totalWeight
    }));
    return totalPortfolios;
}
export function addAccount(accounts, newAccount) {
    var maxAccout = _.maxBy(accounts, "accountId");
    if (maxAccout)
        newAccount.accountId = (maxAccout === null || maxAccout === void 0 ? void 0 : maxAccout.accountId) + 1;
    else
        newAccount.accountId = 1;
    accounts.push(newAccount);
    return accounts;
}
export function addNewAccount(accounts) {
    var newAccount = new InvestmentAccount({
        accountName: "",
        accountMarketValue: 0,
        accountType: 1
    });
    var portfolio = getPortfolios()[0];
    newAccount.portfolios.push({ portfolio: portfolio, weight: 100 });
    var maxAccout = _.maxBy(accounts, "accountId");
    if (maxAccout)
        newAccount.accountId = (maxAccout === null || maxAccout === void 0 ? void 0 : maxAccout.accountId) + 1;
    else
        newAccount.accountId = 1;
    accounts.push(newAccount);
    return accounts;
}
export function removeAccount(accounts, accountId) {
    var final = [];
    for (var p = 0; p < accounts.length; p++) {
        if (accountId != accounts[p].accountId)
            final.push(accounts[p]);
    }
    return final;
}
export function addPortfolioToAccount(account) {
    var portfolios = getPortfolios();
    var weight = 100;
    if (account.portfolios.length > 0)
        weight = 0;
    account.portfolios.push(new PortfolioWeight({ portfolio: portfolios[0], weight: weight }));
    return account;
}
export function changePortfolioInAccount(account, portfolioIndex, portfolioId, weight) {
    var portfolios = getPortfolios();
    console.log("find portfolio with portfolioId", portfolioId);
    var portfolio = _.find(portfolios, ["portfolioId", portfolioId]);
    console.log("portfolio", portfolio);
    console.log("current portfolio", account.portfolios[portfolioIndex].portfolio);
    account.portfolios[portfolioIndex].portfolio = portfolio;
    account.portfolios[portfolioIndex].weight = weight;
    return account;
}
export function removePortfolioFromAccount(account, indx) {
    console.log("account pre", account.portfolios);
    var portfolios = [];
    for (var p = 0; p < account.portfolios.length; p++) {
        if (p != indx)
            portfolios.push(account.portfolios[p]);
    }
    account.portfolios = portfolios;
    console.log("account post", account.portfolios);
    return account;
}
